// After Sales Turbolinks Fixer
// This file ensures all inline scripts using DOMContentLoaded will also work with Turbolinks

// Store all DOMContentLoaded handlers
const domContentLoadedHandlers = [];

// Override the native addEventListener to capture DOMContentLoaded handlers
const originalAddEventListener = document.addEventListener;
document.addEventListener = function(type, listener, options) {
  if (type === 'DOMContentLoaded') {
    // Store the handler for later execution on turbolinks:load
    domContentLoadedHandlers.push(listener);
  }
  
  // Still call the original method
  return originalAddEventListener.call(this, type, listener, options);
};

// Execute all the DOMContentLoaded handlers when turbolinks:load fires
document.addEventListener('turbolinks:load', function() {
  console.log(`[Turbolinks Fixer] Re-running ${domContentLoadedHandlers.length} DOMContentLoaded handlers`);
  
  // Execute all stored handlers
  domContentLoadedHandlers.forEach(handler => {
    try {
      handler();
    } catch (e) {
      console.error('[Turbolinks Fixer] Error executing handler:', e);
    }
  });
});

// Function to re-initialize any inline scripts
function initializeInlineScripts() {
  console.log('[Turbolinks Fixer] Initializing page-specific handlers');
  
  // NOTE: DataTable initialization is handled by datatable.js with specific configurations
  // Do NOT auto-initialize datatables here to avoid conflicts with custom column definitions
  
  // NOTE: Select2 initialization is handled by application.js and after_sales_select2_helper.js
  // Do NOT auto-initialize select2 here to avoid conflicts
  
  // Handle flash messages
  const flashMessages = document.querySelectorAll('.flash-message .dismiss-flash');
  flashMessages.forEach(button => {
    if (!button.hasAttribute('data-initialized')) {
      button.setAttribute('data-initialized', true);
      button.addEventListener('click', function() {
        const flashElement = this.closest('.flash-message');
        if (flashElement) {
          flashElement.classList.add('opacity-0');
          setTimeout(() => {
            flashElement.remove();
          }, 300);
        }
      });
    }
  });
  
  // Re-initialize barcode scanner if present
  if (typeof window.initBarcodeScanner === 'function' && 
      document.getElementById('scanner-container')) {
    window.initBarcodeScanner();
  }
  
  // Re-initialize form-specific handlers
  if (document.querySelector('form')) {
    initializeFormHandlers();
  }
}

// Form-specific handlers
function initializeFormHandlers() {
  // Handle nested form fields (Cocoon)
  if (typeof $ !== 'undefined') {
    $(document).off('cocoon:after-insert').on('cocoon:after-insert', function(e, insertedItem) {
      // Re-initialize select2 on newly added nested form elements
      if (typeof $.fn.select2 !== 'undefined') {
        $(insertedItem).find('select.select2').select2({
          width: '100%',
          placeholder: $(this).data('placeholder') || 'Select an option'
        });
      }
    });
  }
  
  // Handle dynamic part additions in service jobs
  const addPartButton = document.getElementById('add-part-button');
  if (addPartButton && !addPartButton.hasAttribute('data-initialized')) {
    addPartButton.setAttribute('data-initialized', true);
    addPartButton.addEventListener('click', function(e) {
      e.preventDefault();
      // Call the handler function if it exists
      if (typeof window.addServicePart === 'function') {
        window.addServicePart();
      }
    });
  }
  
  // Handle date pickers if present
  const datePickers = document.querySelectorAll('input[type="date"]');
  datePickers.forEach(picker => {
    if (!picker.hasAttribute('data-initialized') && typeof $ !== 'undefined' && typeof $.fn.datepicker !== 'undefined') {
      picker.setAttribute('data-initialized', true);
      $(picker).datepicker({
        format: 'yyyy-mm-dd',
        autoclose: true
      });
    }
  });
}

// Clean up before caching the page
document.addEventListener('turbolinks:before-cache', function() {
  // Clean up datatables - SAFELY check if each table is initialized before destroying
  if (typeof $ !== 'undefined' && typeof $.fn.DataTable !== 'undefined') {
    $('.dataTable').each(function() {
      try {
        if ($.fn.DataTable.isDataTable(this)) {
          $(this).DataTable().destroy();
        }
      } catch (e) {
        console.warn('[Turbolinks Fixer] Error destroying datatable:', e);
      }
    });
  }
  
  // Clean up select2 - SAFELY
  if (typeof $ !== 'undefined' && typeof $.fn.select2 !== 'undefined') {
    try {
      $('.select2-hidden-accessible').each(function() {
        $(this).select2('destroy');
      });
    } catch (e) {
      console.warn('[Turbolinks Fixer] Error destroying select2:', e);
    }
  }
  
  // Clean up any scanner instances
  if (window.scannerActive) {
    if (window.scannerType === 'quagga' && window.Quagga) {
      window.Quagga.stop();
    } else if (window.scannerType === 'jsqr' && window.videoElement && window.videoElement.srcObject) {
      window.videoElement.srcObject.getTracks().forEach(track => track.stop());
    }
    window.scannerActive = false;
  }
  
  // Reset sidebar on mobile only
  const sidebar = document.querySelector('.sidebar-container');
  if (sidebar && window.innerWidth < 768) {
    sidebar.classList.add('hidden');
    sidebar.style.display = 'none';
  }
});

// Run initializers on both page load and Turbolinks navigation
document.addEventListener('DOMContentLoaded', initializeInlineScripts);
document.addEventListener('turbolinks:load', initializeInlineScripts);

// Export for use in other files
export { initializeInlineScripts };
